import type { Film } from '@vista-digital/ocapi-types/v1'
import { useMemo } from 'react'

export const useEstrenoTag = (film: Film | null | undefined, numberOfDaysConsideredNewRelease?: number): boolean => {
    return useMemo(() => {
        if (!film || !film.releaseDate || !numberOfDaysConsideredNewRelease) {
            return false
        }

        const today = new Date()
        today.setHours(0, 0, 0, 0)

        const releaseDate = new Date(film.releaseDate)
        if (isNaN(releaseDate.getTime())) {
            return false
        }
        releaseDate.setHours(0, 0, 0, 0)

        const diffMs = today.getTime() - releaseDate.getTime()
        const diffDays = diffMs / (1000 * 60 * 60 * 24)

        // Visible from release date, until release date + numberOfDaysConsideredNewRelease
        return diffDays >= 0 && diffDays < numberOfDaysConsideredNewRelease
    }, [film, numberOfDaysConsideredNewRelease])
}
